<h4>About app</h4>

<div class="row info-section">
  <div class="col-sm-6">
    <div class="card" *ngIf="serverBuildInfo">
      <div class="card-body">
        <h5 class="card-title">Server build info</h5>
        <ul class="card-text">
          <li>Branch name: {{serverBuildInfo.branchName }}</li>
          <li>Build number: {{serverBuildInfo.buildNumber }}</li>
          <li>Build ID: {{serverBuildInfo.buildId }}</li>
          <li>Commit hash: {{serverBuildInfo.commitHash }}</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <div class="card" *ngIf="clientBuildInfo">
      <div class="card-body">
        <h5 class="card-title">Client build info</h5>
        <ul class="card-text">
          <li>Branch name: {{clientBuildInfo.branchName }}</li>
          <li>Build number: {{clientBuildInfo.buildNumber }}</li>
          <li>Build ID: {{clientBuildInfo.buildId }}</li>
          <li>Commit hash: {{clientBuildInfo.commitHash }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="row form-section">
  <div class="col-sm-12">
    <form #myForm="ngForm" (ngSubmit)="handleSubmit()">
      <div class="form-group row">
        <label class="col-form-label col-md-3 col-lg-2">Name</label>
        <div class="col-md-5">
          <input #nameField="ngModel" class="form-control" type="text" [(ngModel)]="user.name" name="name" id="name" required>
          <div *ngIf="nameField.errors && (nameField.dirty || nameField.touched)">
            <p *ngIf="nameField.errors.required" class="error-text medium">Name is required.</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-md-3 col-lg-2">Email</label>
        <div class="col-md-5">
          <input #emailField="ngModel" class="form-control" type="text" [(ngModel)]="user.email" name="email" id="email" required>
          <div *ngIf="emailField.errors && (emailField.dirty || emailField.touched)">
            <p *ngIf="emailField.errors.required" class="error-text medium">Email is required.</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-md-3 col-lg-2">Age</label>
        <div class="col-md-5">
          <input #ageField="ngModel" class="form-control" type="number" [(ngModel)]="user.age" name="age" id="age" required>
          <div *ngIf="ageField.errors && (ageField.dirty || ageField.touched)">
            <p *ngIf="ageField.errors.required" class="error-text medium">Age is required.</p>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col">
          <button class="btn btn-primary" type="submit" [disabled]="!myForm.valid">Submit</button>
        </div>
      </div>
    </form>
  </div>
</div>

